/*
 *
 * AboutUs constants
 *
 */

export const DEFAULT_ACTION = '/ContactUs/DEFAULT_ACTION';
export const CONATCTUS_SUCCESS = '/ContactUs/CONATCTUS_SUCCESS';
export const DEFAULT_PAYLOAD = {
  name: '',
  email: '',
  phone: '',
  message: '',
  subject: '',
};



// WEBPACK FOOTER //
// client/containers/ContactUs/constants.js